module.exports = __webpack_public_path__ + "static/media/33GovernorsStudy.98755850.jpg";